
<template>
  <div class="business-pc">
    <div class="business-box">
      <div class="business-top">
        <div class="business-top-title">
          主营业务
        </div>
        <div class="business-top-content">
          目前公司的主要业务有：实体彩票店竞彩销量提升帮扶项目（线下）、彩票实战营销培训项目、采道线上平台运营项目（含采道特训营线上实训帮扶）、采道实体店运营项目四大板块。
        </div>
      </div>

      <div class="business-content">
        <div class="business-content-item" v-for="(item, index) in list" :key="item.id">
          <img v-if="!(index % 2)"  :src="require(`@/assets/images/business-${item.id}.png`)"  alt="">
          <div class="business-content-text">
            <div class="business-content-title">{{item.title}}</div>
            <div class="business-content-content">{{item.content}}</div>
            <div v-if="item.morePath" class="business-content-more" @click="$router.push(item.morePath)">了解更多&gt;&gt;</div>
          </div>
          <img v-if="index % 2"  :src="require(`@/assets/images/business-${item.id}.png`)"  alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'business-pc',

  data () {
    return {
      list: [
        {
          id: 1,
          title: '实体彩票店竞彩销量提升帮扶项目',
          content: '自2015年开始，嘉彩科讯团队前身开始开展彩票网点经营能力提升帮扶项目，七年时间内，直接帮助近3000个月销三万元以下的低销量彩票网点实现了成倍、成十倍的增长，帮助上千个代销者从一个月收入不足2000元的低保人群逐步发展成为年收入上百万的行业达人。通过对七年的实体店帮扶工作经验的总结，嘉彩团队提炼出了一整套实战性强、高效率的系统化彩票销售理念。',
          morePath: '/shopkeeperHelp'
        },
        {
          id: 2,
          title: '彩票实战营销培训项目',
          content: '如果我们把竞彩月销100万设定为目标的话，彩票实战营销培训项目就是找个教练兼队友陪你一起打怪升级，在三到四个月内实现和完成这个目标。“主动参与、主动管理”是彩票实战营销培训项目别于目前市场上很多其他彩票培训产品的最大特点，彩票实战营销培训项目采用“小班教学、真人实训”的方式开展为期2-3个月的实战教学。参加彩票实战营销培训项目，相当于得到了一次系统的彩票店经营理论学习机会和3个月的“贴身教练”24小时服务指导机会。优秀学员还有机会参加采道官方举办的“财道发展论坛”与全国优秀彩票店主面对面交流。'
        },
        // {
        //   id: 3,
        //   title: '采道线上平台运营项目',
        //   content: '采道平台是嘉彩科讯开发的为彩票从业者和爱好者服务的一个互联网平台，初心就是在合法合规的情况下帮助彩票店主赚钱，增加彩票店主收益。采道平台以增加彩票店主收入，拓展彩票店主收入渠道为平台的方向发展。当然为彩票店主提供彩票店主帮扶项目、提供彩票店主日常运营所需的各类海报、视频、文案等资源，是采道平台最基本的工作。为彩票爱好者提供赛事资讯和数据服务。',
        //   morePath: '/caidaoApp'
        // },
        {
          id: 4,
          title: '采道实体店运营项目',
          content: '2021年5月份开始，嘉彩科讯市场团队开始在武汉市对59个便利店/超市等彩票兼营网点进行试点帮扶，短短8个月时间培养出了4个月销量过百万的明星网点，受帮扶的32个有效帮扶网点电脑型彩票的平均月销量达到了18.75万元，平均单点每月佣金收入超过1.2万元。'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.business-pc {
  .business-box {
    padding: 120px 0 200px;
    @extend .container--pc;

    .business-top {
      width: 100%;
      text-align: center;

      .business-top-title {
        margin-bottom: 25px;
        font-size: 36px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: $base-color;
        line-height: 42px;
      }

      .business-top-content {
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
      }
    }

    .business-content {
      .business-content-item {
        height: 667px;
        margin-top: 180px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 115px;

        &:nth-child(1) {
          margin-top: none;
        }

        .business-content-text {
          height: 100%;
          @include flex(col, center);
          .business-content-title {
            margin-bottom: 20px;
            font-size: 32px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 56px;
          }

          .business-content-content {
            margin-bottom: 20px;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #666666;
          }

          .business-content-more {
            cursor: pointer;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
